import {Dispatch, SetStateAction, useState} from 'react';
import { LoaderOverlay } from '@/components';
import { State, NewBuildingModel } from '@/types';
import { useSelector } from 'react-redux';
import { pdf } from '@react-pdf/renderer';
import { useUserData } from '@/components/PdfManager/useUserData';
import { UnitsPdfSettings } from './UnitsPdfSettings';
import { GenerateUnitPDF } from './PdfDocument/GenerateUnitPDF';
import { IUnit } from '@/types/offplans';

type IPdfTemplateImagesRules = {
  name: string;
  minHeaderPicsCount: number;
  bestHeaderPicsCount: number;
};


export const UnitsPdfManager = ({
  offplanId,
  units,
  totalUnits = 0,
  offplanData,
}: {
  offplanId: string;
  units: IUnit[];
  totalUnits: number;
  totalPlans: number;
  offplanData?: NewBuildingModel;
}) => {
  const user = useSelector(({ auth }: State) => auth.user);
  const [isLoading, setIsLoading] = useState(false);
  const [showMyContactsCheckbox, setShowMyContactsCheckbox] = useState(true);

  const { userData: currentAgencyInfo } = useUserData(user.employer?.id);

  const [isViewPdfVisible, setIsViewPdfVisible] = useState(false)
  const [pdfFile, setPdfFile] = useState<Blob | null>(null)
  return (
    <div style={{ width: '100%' }}>

      {isLoading && <LoaderOverlay />}
      <UnitsPdfSettings
        showMyContactsCheckbox={showMyContactsCheckbox}
        pdfFile={pdfFile}
        units={units}
        isViewPdfVisible={isViewPdfVisible}
        hideViewPdf={() => setIsViewPdfVisible(false)}
        onSubmit={async (data) => {
          setIsLoading(true);
          const templateName = data.radioOption.toString();
          const blob = await pdf(
            <GenerateUnitPDF
              templateName={templateName}
              offplanData={offplanData}
              personalInfo={user}
              units={units}
              currentAgencyInfo={currentAgencyInfo}
              // isNumberOfFloorsShown={isNumberOfFloorsShown}
              showContent={{
                // images: tImages,
                isAgencyInformationVisible: data.agencyDetailsShow,
                isBrokersInformationVisible: showMyContactsCheckbox
                  ? data.brokerDetailsShow
                  : data.agencyDetailsShow,
                showPrice: data.showPrice,
              }}
            />
          ).toBlob();
          const res = await documentSave(blob, `${offplanId}`, setPdfFile);
          setIsViewPdfVisible(true)
          if (res) setIsLoading(false);
        }}
      />
    </div>
  )
    
}

export async function documentSave(blob: Blob, documentName: string, setPdfFile: Dispatch<SetStateAction<Blob | null>>): Promise<string> {
  try {
    const objectUrl = URL.createObjectURL(blob);
    setPdfFile(blob)
    const fileExtension = blob.type.split('/')[1];

    const fileName = `${documentName}.${fileExtension}`
      .replace(/\s/g, '_')
      .replace(/[^a-zA-Z0-9_.]/g, '');

    const link = window.document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    link.style.display = 'none';

    document.body.appendChild(link);

    link.click();
    link.remove();

    URL.revokeObjectURL(objectUrl);

    return 'ok';
  } catch (error) {
    console.error('Error in documentSave:', error);
    return 'error';
  }
}


